import { IS_MAINNET, IS_TESTNET } from '@shared/utils/constant'

export const RFQ_WS_URL = IS_MAINNET
  ? 'wss://rfq.ws.injective.network'
  : IS_TESTNET
    ? 'wss://testnet.rfq.ws.injective.network'
    : 'wss://devnet.api.injective.dev'

export const RFQ_CONTRACT_ADDRESS = IS_MAINNET
  ? 'inj12stwq95jet57edcu4a65r48r46s9rzrs938n8k'
  : IS_TESTNET
    ? 'inj1qw7jk82hjvf79tnjykux6zacuh9gl0z0wl3ruk'
    : 'inj19g43wyj843ydkc845dcdea6su4mgfjwnpjz6h5'

export const RFQ_COLLECT_QUOTES_TIME = 500 // 0.5 second
export const INITIATE_RFQ_MID_PRICE_TIMEOUT = 3000 // 3 seconds

export const DEFAULT_RFQ_PRE_QUOTING_AMOUNT = '10' // 10 USD

export const RFQ_PRE_QUOTE_INTERVAL = 1000 // 1 second
export const RFQ_PRE_QUOTE_TIMEOUT_INTERVAL = RFQ_PRE_QUOTE_INTERVAL - 200
export const RFQ_DEBOUNCE_DEFAULT_PERIOD = 1000 // 1 second
export const RFQ_GATEWAY_PREPARE_DEBOUNCE_MS = 300
export const RFQ_GATEWAY_PREFETCH_REFRESH_INTERVAL_MS = 1000
export const RFQ_GATEWAY_PREFETCH_MAX_PREPARE_CALLS = 5
export const RFQ_GATEWAY_IN_FLIGHT_PREPARE_SUBMIT_TIMEOUT_MS = 300
export const RFQ_GATEWAY_CLOSE_POSITION_IN_FLIGHT_PREPARE_SUBMIT_TIMEOUT_MS = 1000
export const RFQ_GATEWAY_PREPARED_RESPONSE_MAX_AGE_MS = 1000
export const RFQ_CLIENT_GATEWAY_GAS_LIMIT = 2_500_000
export const RFQ_CLIENT_GATEWAY_ACK_TIMEOUT_BUFFER_MS = 5000
export const RFQ_GATEWAY_QUOTE_EARLY_CLOSE_MIN_QUOTES = 1
export const RFQ_GATEWAY_QUOTE_EARLY_CLOSE_MIN_QUANTITY = 1

export const RFQ_PREQUOTE_SLIPPAGE_TIERS = [
  0.2, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5
]
export const RFQ_PREQUOTE_MAX_ATTEMPTS_BEFORE_ESCALATION = 2

export const DEFAULT_RFQ_TPSL_SLIPPAGE = 0.5 // 0.5%
export const DEFAULT_RFQ_TPSL_NONCE_MS = 60_000 // 60 seconds
export const RFQ_TPSL_MIN_QUANTITY_FILLED_PERCENTAGE = 0.1 // 10%
export const RFQ_TPSL_DEADLINE_MS = 21 * 24 * 60 * 60 * 1000 // 21 days
